import React, { memo } from 'react'
import { InsuranceBeneficiaryForm } from 'src/components/client/insurance-beneficiary-form/InsuranceBeneficiaryForm'

const InsuranceBeneficiaryPageComponent = () => {
  return <InsuranceBeneficiaryForm />
}

export const InsuranceBeneficiaryPage = memo(InsuranceBeneficiaryPageComponent)
